import React from 'react';
import styled from 'styled-components';
import ButtonSmall from '../../../../shared/components/button-small';
import Font from '../../../../shared/typography/Font';

const Container = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 13px 17px;

  border-radius: 8px;
  width: 100%;
  height: 48px;

  box-shadow: 0px 2px 8px rgba(27, 33, 36, 0.16);

  #freeTrial {
    font-weight: 600;
  }
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 12px;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 12px;

  > *:last-child {
    font-size: 12px;
  }
`;

interface StartTrialOrSubscribeMoleculeProps {
  // eslint-disable-next-line react/no-unused-prop-types
  onClickWatchDemo: () => void,
}

const WatchDemoCardMol = ({
  onClickWatchDemo,
}: StartTrialOrSubscribeMoleculeProps) => (
  <Container>
    <TextContainer>
      <Font font="defaultSmall" id="freeTrial">
        Watch a quick product demo
      </Font>
    </TextContainer>
    <ButtonContainer>
      <ButtonSmall padding="0px 12px" text="Watch demo" onClick={onClickWatchDemo} />
    </ButtonContainer>
  </Container>
);

export default WatchDemoCardMol;
